import { useMetamask } from '../../contexts/Metamask';
import Button from 'components/Button';
import classes from './Navbar.module.scss';
import { APP_CONFIG, ContractAddress } from 'config';

export default function Navbar() {
  const { account, disconnect, isConnectedToAllowedNetwork } = useMetamask();

  const addTokenToWallet = async () => {
    if (!(await isConnectedToAllowedNetwork())) return;

    try {
      await (window as any).ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20',
          options: {
            address: ContractAddress.Token,
            symbol: 'NUM',
            decimals: 18,
            image: 'https://assets.website-files.com/6148548ab244696560ef92dd/614c90769fa6f91f94b6f5ed_Favicon.png',
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <nav className={classes.nav}>
      <img src={APP_CONFIG.COMPANY.LOGO} alt={`${APP_CONFIG.COMPANY.NAME} Logo`} className={classes.logo} />
      <Button
        className={classes.button}
        onClick={addTokenToWallet}
        text={`Add ${APP_CONFIG.VESTING_TOKEN} to Metamask`}
      />
      {account && (
        <>
          <Button className={classes.button} onClick={disconnect} text="Disconnect" />
          <p className={classes.walletAddress}>
            {account?.substr(0, 6) + '...' + account.substr(account.length - 5)}
          </p>
        </>
      )}
    </nav>
  );
}
